export default __webpack_public_path__ + "static/media/slayder5.5770d79d.jpg";